import React, { Component } from 'react'
import { reduxForm, reset, Field } from 'redux-form'

import { InputField } from '../../components/inputs'
import { ReduxFormProps } from '../../forms'

export interface FormProps {
  findSelect: string
}

export class LookupForm extends Component<ReduxFormProps<object, FormProps>> {
  render() {
    const { handleSubmit /*, pristine, submitting*/ } = this.props

    return (
      <form
        className="form lookup__form"
        name="LookupForm"
        onSubmit={handleSubmit}
      >
        <Field
          type="search"
          gridClass="lookup__form__group--input"
          className="lookup__input-search lookup__drive-america"
          name="findInput"
          component={InputField}
        />
      </form>
    )
  }
}

const afterSubmit = (result, dispatch) => dispatch(reset('LookupForm'))

export default reduxForm<FormProps, object>({
  form: 'LookupForm',
  onSubmitSuccess: afterSubmit,
})(LookupForm)
